import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Typography from 'components/global/Typography';

import * as S from './LogoViewer.styled';

const CountryViewer = ({ value }) => {
	const { t } = useTranslation();

	const calculatedLocalValue = useMemo(() => {
		const valueWithPrefix = `country.${value}`;
		const translatedValueWithPrefix = t(valueWithPrefix);
		if (translatedValueWithPrefix !== valueWithPrefix) {
			return `country.${value}`;
		}

		return value;
	}, [value]);

	return (
		<S.Container>
			<div>
				<div className={`oto-country-flag flag-${value?.toLowerCase()}`} />
			</div>
			<Typography>{calculatedLocalValue}</Typography>
		</S.Container>
	);
};

export default CountryViewer;
